import React, { useEffect, useState } from 'react';
import {
  ListItem,
  Avatar,
  IconArrowRight,
} from '@Knowledge-OTP/znk-ui-components';
import { TabPane, TabContent } from 'reactstrap';
import RenderInputOption from '../../../../../newPlanModal/Components/RenderInputOption';
import useAddCounselorModal from './Modal/AddCounselorModal/useAddCounselorModal';
import useUpdateTeamMembers from './Model/useUpdateTeamMembers'
import { showAlert } from '../../../../../../../../common/Alert/util';
import { useDispatch } from 'react-redux';
import useCounselingPlanList from '../../../../../../../CounselingPlans/useCounselingPlanList';

const skeletonAnimation = `
  @keyframes shimmer {
    0% {
      background-position: -1000px 0;
    }
    100% {
      background-position: 1000px 0;
    }
  }

  .skeleton-avatar {
    background: linear-gradient(to right, #f0f0f0 8%, #e0e0e0 18%, #f0f0f0 33%);
    background-size: 2000px 100%;
    animation: shimmer 2s infinite linear;
    border-radius: 50%;
  }

  .skeleton-text {
    background: linear-gradient(to right, #f0f0f0 8%, #e0e0e0 18%, #f0f0f0 33%);
    background-size: 2000px 100%;
    animation: shimmer 2s infinite linear;
    height: 20px;
    border-radius: 4px;
  }

  .skeleton-icon {
    background: linear-gradient(to right, #f0f0f0 8%, #e0e0e0 18%, #f0f0f0 33%);
    background-size: 2000px 100%;
    animation: shimmer 2s infinite linear;
    width: 24px;
    height: 24px;
    border-radius: 4px;
  }
`;

const Team = (props) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const { className, plan } = props;
  const [counselorData, setCounselorData] = useState({});
  const [headData, setHeadData] = useState({});
  const { refetch } = useCounselingPlanList()

  useEffect(() => {
    // Add styles to document head
    const style = document.createElement('style');
    style.textContent = skeletonAnimation;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    if (plan?.counselorData && !data?.counselorData) {
      setCounselorData({
        councelorName: `${plan?.counselorData?.firstName} ${plan?.counselorData?.lastName}`,
        councelorAvatar: plan?.aditionalInfo?.avatarCouncelor,
      });
    }

    if (data?.counselorData) {
      setCounselorData({
        activeTab: 'selected',
        councelorName: `${data?.counselorData?.firstName} ${data?.counselorData?.lastName}`,
        councelorAvatar: data?.counselorData?.avatarCouncelor,
      });
    }

    return () => {
      // Cleanup function
      setCounselorData({});
    };
    // eslint-disable-next-line
  }, [plan?.counselorData, data]);


  useEffect(() => {
    if (plan?.headData && !data?.headData) {
      setHeadData({
        headName: `${plan?.headData?.firstName} ${plan?.headData?.lastName}`,
        headAvatar: plan?.aditionalInfo?.avatarHead,
      });
    }
    if (data?.headData) {
      setHeadData({
        headName: `${data?.headData?.firstName} ${data?.headData?.lastName}`,
        headAvatar: data?.headData?.avatarHead,
      });
    }
    return () => {
      // Cleanup function
      setHeadData({});
    };
    // eslint-disable-next-line
  }, [plan?.headData, data]);

  // const { advisorName, advisorAvatar } = useMemo(() => {
  //   if (plan?.advisorData) {
  //     return {
  //       advisorName: `${plan?.advisorData?.firstName} ${plan?.advisorData?.lastName}`,
  //       advisorAvatar: plan?.aditionalInfo?.avatarAdvisor,
  //     };
  //   }
  //   return {};
  // }, [plan?.advisorData]);

  const { open, close } = useAddCounselorModal();

  const openAddCounselor = (defaultCounselors = []) => {
    open(
      (counselors) => {
        if (counselors?.length > 0) {
          setData((prevData) => ({
            ...prevData,
            counselor: counselors[0].id,
            counselorData: {
              ...counselors[0],
              teamUserId: counselors[0].id,
            },
          }));
          close();
          setTeamMembers({
            variables: {
              planId: plan.id,
              counselorId: counselors[0].id,
            },
          });
        }
      },
      false,
      defaultCounselors
    );
  };

  const openAddHead = (defaultHead = []) => {
    open(
      (counselors) => {
        if (counselors?.length > 0) {
          setData((prevData) => ({
            ...prevData,
            head: counselors[0].id,
            headData: {
              ...counselors[0],
              teamUserId: counselors[0].id,
            },
          }));
        }
        close();
        setTeamMembers({
          variables: {
            planId: plan.id,
            headId: counselors[0].id,
          },
        });
      },
      false,
      defaultHead
    );
  };

  const onCompleted = (result) => {
    showAlert({
      text: 'Team members updated successfully',
      status: 'success'
    }, dispatch);

    if (result?.updateTeamCounselingPlan) {
      setCounselorData({
        councelorName: `${result?.updateTeamCounselingPlan?.councelor?.firstName} ${result.updateTeamCounselingPlan.councelor.lastName}`,
        councelorAvatar: result?.updateTeamCounselingPlan?.councelor?.avatarCouncelor || null,
      });
      setHeadData({
        headName: `${result?.updateTeamCounselingPlan?.head?.firstName} ${result.updateTeamCounselingPlan.head.lastName}`,
        headAvatar: result?.updateTeamCounselingPlan?.head?.avatarHead || null,
      });
    }
    //setData({})
    refetch();
  };

  const onError = (error) => {
    showAlert({
      text: `An error occurred while updating team members: ${error.message}`,
      status: 'error'
    }, dispatch);
  };

  const [setTeamMembers, { loading }] = useUpdateTeamMembers(
    onCompleted,
    onError
  );

  return (
    <div className={`m-0 p-0 d-flex flex-column ${className}`}>
      <span className={`h4 font-weight-bold text-title`}>Team</span>
      <RenderInputOption key={"planName"} label={null}>
        <TabContent activeTab={"selected"}>
          <TabPane tabId={"selected"}>
            <ListItem
              className="py-1 appears-animation"
              id="x-0"
              label={null}
              onClick={['scheduled', 'application', 'post-application'].includes(plan?.status) ? openAddCounselor : null}
              Left={
                <div className="d-flex flex-row align-items-center">
                  {loading ? (
                    <div
                      className="skeleton-icon"
                      style={{ "background-color": "#000" }}
                    />
                  ) : (
                    <Avatar
                      name={counselorData?.councelorName}
                      named={false}
                      uri={counselorData?.councelorAvatar}
                      size="avatar-medium"
                    />
                  )}
                  <label className="ml-2 h4 align-self-center">
                    {loading ? (
                      <div className="skeleton-icon" />
                    ) : (
                      <>
                        {counselorData?.councelorName}
                        <span className="ml-2 text-gray h45">
                          (Student Success Coordinator)
                        </span>
                      </>
                    )}
                  </label>
                </div>
              }
              Right={
                <div className="hover-icon">
                  {loading ? (
                    <div className="skeleton-text" />
                  ) : ['scheduled', 'application', 'post-application'].includes(plan?.status) ? (
                    <IconArrowRight />
                  ) : null}
                </div>
              }
            />
            {/* {advisorName && (
              <ListItem
                className="py-1 appears-animation"
                id="x-0"
                label={null}
                Left={
                  <div className="d-flex flex-row align-items-center">
                    <Avatar
                      name={advisorName}
                      named={false}
                      uri={advisorAvatar}
                      size="avatar-medium"
                    />
                    <label className="ml-2 h4 align-self-center">
                      {advisorName}
                      <span className="ml-2 text-gray h45">(Advisor)</span>
                    </label>
                  </div>
                }
                Right={
                  <div className="hover-icon">
                    <IconArrowRight />
                  </div>
                }
              />
            )} */}
            {headData?.headName && (
              <ListItem
                className="py-1 appears-animation"
                id="x-0"
                label={null}
                onClick={['scheduled', 'application', 'post-application'].includes(plan?.status) ? openAddHead : null}
                Left={
                  <div className="d-flex flex-row align-items-center">
                    {loading ? (
                      <div
                        className="skeleton-icon"
                        style={{ "background-color": "#000" }}
                      />
                    ) : (
                      <Avatar
                        name={headData?.headName}
                        named={false}
                        uri={headData?.headAvatar}
                        size="avatar-medium"
                      />
                    )}
                    <label className="ml-2 h4 align-self-center">
                      {loading ? (
                        <div className="skeleton-icon" />
                      ) : (
                        <>
                          {headData?.headName}
                          <span className="ml-2 text-gray h45">
                            (Head Counselor)
                          </span>
                        </>
                      )}
                    </label>
                  </div>
                }
                Right={
                  <div className="hover-icon">
                    {loading ? (
                      <div className="skeleton-text" />
                    ) : ['scheduled', 'application', 'post-application'].includes(plan?.status) ? (
                      <IconArrowRight />
                    ) : null}
                  </div>
                }
              />
            )}
          </TabPane>
        </TabContent>
      </RenderInputOption>
    </div>
  );
};

export default Team;
